export const PhoneFrame = ({ children, testId }) => (
  <div
    data-testid={testId}
    className="relative mx-auto flex h-[560px] w-full max-w-[290px] flex-col overflow-hidden rounded-[2.4rem] border border-white/15 bg-[#0b0d12] p-2 shadow-[0_30px_80px_-30px_rgba(255,107,0,0.45)] lg:h-full lg:max-h-[580px]"
  >
    <div className="relative flex h-full flex-col overflow-hidden rounded-[2rem] bg-[#07080b]">
      <div className="absolute left-1/2 top-2 z-20 h-5 w-24 -translate-x-1/2 rounded-full bg-black" />
      {children}
    </div>
  </div>
);
